var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.902 14.863C15.456 14.3091 15.8954 13.6515 16.1951 12.9277C16.4949 12.204 16.6492 11.4283 16.6492 10.6449C16.6492 9.86156 16.4949 9.08586 16.1951 8.36213C15.8954 7.63839 15.456 6.98079 14.902 6.42686C14.3481 5.87294 13.6905 5.43354 12.9668 5.13376C12.243 4.83398 11.4673 4.67969 10.684 4.67969C9.90062 4.67969 9.12492 4.83398 8.40119 5.13376C7.67745 5.43354 7.01985 5.87294 6.46593 6.42686C5.34723 7.54556 4.71875 9.06284 4.71875 10.6449C4.71875 12.227 5.34723 13.7443 6.46593 14.863C7.58462 15.9817 9.10191 16.6102 10.684 16.6102C12.2661 16.6102 13.7833 15.9817 14.902 14.863ZM14.902 14.863L19.8363 20.0117",
    stroke: "#26445A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b7d35369a23d55dd1ead68b63b36f8dd.svg";
export { ForwardRef as ReactComponent };